module.exports = "<things-list></things-list>\r\n<areas-edit></areas-edit>\r\n<!-- <app-test-restroom-group-edit></app-test-restroom-group-edit> -->"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/task/cot-web/src/app/pages/things/things.component.html
// module id = ../../../../../src/app/pages/things/things.component.html
// module chunks = main